import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import {
  ClientPersonalDetailsViewModel,
  ClientDetailsGetClientPersonalDetailsRequest,
  ResultOfClientPersonalDetailsViewModel
} from 'bff/client';

export const useInvalidatePersonalDetails = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: ['ClientInformation'],
      refetchType: 'all'
    });
};

export const usePersonalDetailsQuery = (
  request: ClientDetailsGetClientPersonalDetailsRequest,
  isEnabled: boolean
): UseQueryResult<ClientPersonalDetailsViewModel | undefined, Error> => {
  const { clientDetailsApi } = useApiClient();

  return useQuery<
    ResultOfClientPersonalDetailsViewModel,
    Error,
    ClientPersonalDetailsViewModel | undefined
  >({
    queryKey: ['ClientInformation', request.clientId],
    queryFn: () => clientDetailsApi.clientDetailsGetClientPersonalDetails(request),
    select: (response) => response.data,
    refetchOnWindowFocus: false,
    enabled: isEnabled
  });
};
